import * as CONSTANTS from '../../constants';

export default {

    /**
     * Mutation to toggle the info widget. Use payload to force open or close.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.INFO_WIDGET_TOGGLE] (state, payload) {
        if(payload !== undefined) {
            state.open = payload;
        } else {
            state.open = !state.open;
        }
    },

    /**
     * Sets the page for the info widget.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.INFO_WIDGET_PAGE_SELECT] (state, payload) {
        state.page = payload;
    },

    /**
     * Increments the page for the info widget, if last page then move to first.
     *
     * @param state
     * @param payload
     */
    [CONSTANTS.INFO_WIDGET_PAGE_INCREMENT] (state, payload) {
        state.page = ((state.page + 1) % payload);
    },

    /**
     * Reset the page
     * @param state
     */
    [CONSTANTS.INFO_WIDGET_PAGE_RESET] (state) {
        state.page = 0;
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/info/mutations.js